import _ from 'lodash';
import moment from 'moment';
import templateStr from 'text!./renewal-payroll.html';
import 'portalConfig';
import DateUtil from 'gw-portals-util-js/DateUtil';
import PropertyCodeViewDirective from 'edge/platform/widgets/typeahead/matchContentDirectives/PropertyCode/PropertyCode';
import PropertyCodeUtil from 'edge/quoteandbind/common/util/PropertyCodeUtil';
import ViewModelUtil from 'edge/gw-portals-bop-components-angular/node_modules/gw-portals-viewmodel-js/ViewModelUtil.js';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        transclude: true,
        scope: {
            hideForm: '&',
            renewalData: '=',
            saveCoveredEmployees: '&',
            perCapitaClasses: '=?'
        },
        controller: ['$scope', 'PolicyService', 'UserService', 'RenewalService', 'qnb.PropertyCodeLookupService', '$window', '$q', 'ModalService', 'ViewModelService', '$state', '$filter', function ($scope, PolicyService, UserService, RenewalService, PropertyCodeLookupService, $window, $q, ModalService, ViewModelService, $state, $filter) {
            $scope.isSubmitting = false;
            $scope.renewalComplete = false;
            $scope.selectedEntry = -1;

            $scope.employeeView = ViewModelService.create({}, 'pc', 'edge.capabilities.policy.dto.WCCoveredEmployeeDTO_Ext');
            /**
             * Service call to get all class code for the job number
             * Based on the input value, return the matches with limit of 10
             * @param ("jobNumber", "renewal Data job number has been initiated from Portal")
             * @return ("classCodeDTO[]", "return the classCode array")
             */
            var lookupCodesPromise = RenewalService.getAllClassCodes($scope.renewalData.jobNumber);
            $scope.classcodeLookup = {
                getMatches: function getMatches(userinput) {
                    return lookupCodesPromise.then(function (propertyCodes) {
                        return _(propertyCodes).filter(function (code) {
                            return PropertyCodeUtil.toString(code).toLowerCase().includes((userinput || '').toLowerCase());
                        }).take(10).valueOf();
                    }).catch(function () {
                        return ModalService.showError('gw-portals-bop-components-angular.locationsAndBuildings.building.buildingCtrl.Error retrieving property class code', 'gw-portals-bop-components-angular.locationsAndBuildings.building.buildingCtrl.Please check for errors and try again');
                    });
                },
                toString: function toString(code) {
                    if (ViewModelUtil.isViewModelNode(code)) {
                        return code.value;
                    }

                    return PropertyCodeUtil.toString(code);
                },
                directive: PropertyCodeViewDirective
            };
            /**
             * take the copy of renewal data mSDWCCoveredEmployees and assign it to another scope variable 
             */
            $scope.coveredEmployees = angular.copy($scope.renewalData.mSFWCCoveredEmployees);
            $scope.selectedEntry = -1;

            /**
             * Function to create new employee when click on Add button
             * setting up the location options by using the instance of WCCoveredEmployeeDTO_Ext dto 
             * AvailableValues property used to display the location in drop down 
             */
            $scope.addClass = function () {
                $scope.isAddingNew = true;
                $scope.newEmployee = {
                    basisAmount: null,
                    classCode: '',
                    description: '',
                    location: '',
                    noOfEmployees: null,
                    perCapita: null,
                    suffix: ''

                };
                $scope.employeeView = ViewModelService.create($scope.newEmployee, 'pc', 'edge.capabilities.policy.dto.WCCoveredEmployeeDTO_Ext');
                $scope.employeeLocationView = {
                    aspects: {
                        inputCtrlType: "typelist",
                        required: false,
                        availableValues: $scope.renewalData.mSFLocations,
                        visible: true,
                        get validationMessages() {
                            return ['This is a required field'];
                        }
                    },
                    value: ''

                };
            };

            /**
             * Function to edit an existing employee values when click on edit icon
             * Creating an instance for the WCCoveredEmployeeDTO_Ext DTO and passing the selected employee index 
             * @param ("index", "index of the selected employee record")
             * @param ("employeesData", "employee details contains the data of the selected employee like class code,location,basisAmount")
             * @return ("value of the location", "validation message for the required field")
             */
            $scope.onEdit = function (index, employeesData, type) {
                $scope.selectedType = type;
                $scope.isAddingNew = false;
                $scope.isEditing = true;
                $scope.selectedEntry = index;
                $scope.resetErrors();
                $scope.employeeView = ViewModelService.create(employeesData[index], 'pc', 'edge.capabilities.policy.dto.WCCoveredEmployeeDTO_Ext');

                $scope.employeeLocationView = {
                    aspects: {
                        inputCtrlType: "typelist",
                        required: false,
                        availableValues: $scope.renewalData.mSFLocations,
                        visible: true,
                        get validationMessages() {
                            return ['This is a required field'];
                        },
                        get valid() {
                            return $scope.employeeView.location.value;
                        }
                    },
                    value: $scope.employeeView.location.value

                };
            };

            /**
             * Method to reset all employee errors by setting false value to the errors scope object
             * Translation used to display error message for location,classCode,moreSuffix,noOfEmployees,basis and perCapita field
             */
            $scope.resetErrors = function () {
                $scope.errors = false;
                $scope.employeeErrors = {
                    location: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Location is required.') },
                    classCode: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Class Code is required.') },
                    moreSuffix: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Class Code contains more than one suffix. Please select the appropriate Class Code and Suffix.') },
                    noOfEmployees: { status: false, message: $filter('translate')('Number of employees should be in the range between 0 to 2147483647 without decimal.') },
                    basis: { status: false, message: $filter('translate')('Please use Basis for this class code within the range of 0 to 2147483647 without decimal.') },
                    perCapita: { status: false, message: $filter('translate')('Please use  only Per Capita for this class code within the range of 0 to 2147483647 without decimal.') }
                };
            };

            /**
             * Method to convert the value into currency format
             * @param ("val", "value of the amount")
             * @return ("currency", "converting amount into currency format")
             */
            $scope.toCurrency = function (val) {
                return { amount: val, currency: 'usd' };
            };

            /**
             * Listen classcode field whenever it gets change, 
             * if percapita class code present then make basisAmount as empty
             */
            $scope.$watch('employeeView.value.classCode', function (newVal) {
                var classCode = document.getElementById('gwClassCode');
                if (classCode != null && classCode.querySelector("textarea").value.length > 10) {
                    var input = classCode.querySelector("textarea");
                    if (input.createTextRange) {
                        var part = input.createTextRange();
                        part.moveEnd("character", 0);
                        part.moveStart("character", 0);
                        part.select();
                    } else if (input.setSelectionRange) {
                        input.setSelectionRange(0, 0);
                    }
                }
                /**
                 * conditions to update the suffix error by checking msf class indicator 
                 * service call to get class code for the jobnumber, if classcode indicator value is 00 return true
                 * if not return false
                 * @param ("classcode", "class code value which has been selected from the portal")
                 * @param ("jobNumber", "Renewal job number which has been initiated from the Portal")
                 * @return {void} - assigning boolean value (true /false) based on the response from the service call
                 */
                if (newVal != null && newVal != undefined) {
                    if (newVal.mSFClassIndicator == '00') {
                        RenewalService.getClassCodeBycode(newVal.code, $scope.renewalData.jobNumber).then(function (data) {
                            if (data.length > 1) {
                                $scope.moreSuffix = true;
                            } else $scope.moreSuffix = false;
                        });
                    } else $scope.moreSuffix = false;
                } else $scope.moreSuffix = false;
            });

            /**
             * Method to validate whether the employee has same class code, same suffix and same location or not
             * checking the validation for existing employees and newly added employees
             * @return ("isDuplicateAvailable", "if duplicate values found return true value for isDuplicateAvailable")
             */
            $scope.validateDuplicateClassCode = function () {
                $scope.isDuplicateAvailable = false;
                angular.forEach($scope.renewalData.mSFWCCoveredEmployees, function (eachFirst, firstRecord) {
                    if (eachFirst.classCode.code == $scope.employeeView.classCode.value.code && eachFirst.location.locationDisplayName == $scope.employeeView.location.value.locationDisplayName && eachFirst.classCode.mSFClassIndicator == $scope.employeeView.classCode.value.mSFClassIndicator) {
                        $scope.isDuplicateAvailable = true;
                    }
                });
                angular.forEach($scope.portalCoveredEmployees, function (eachSecond, secondRecord) {
                    if (eachSecond.classCode.code == $scope.employeeView.classCode.value.code && eachSecond.location.locationDisplayName == $scope.employeeView.location.value.locationDisplayName && eachSecond.classCode.mSFClassIndicator == $scope.employeeView.classCode.value.mSFClassIndicator) {
                        $scope.isDuplicateAvailable = true;
                    }
                });
                return $scope.isDuplicateAvailable;
            };

            /**
             * Method to update employee errors
             * translation used to display the error message if any of the fields are invalid 
             * @param ("type", "checking the type is not existing and not newly created from portal")
             * @return {void} - assigning the error message to display if invalid data found
             */
            $scope.updateEmployeeErrors = function (type) {
                if (type != 'existing' && type != 'portal') {
                    //Execute the main method
                    $scope.isDuplicate = $scope.validateDuplicateClassCode();
                }
                var validNumber = new RegExp(/^[0-9]+([,.][0-9]+)?$/);
                $scope.employeeErrors = {
                    location: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Location is required.') },
                    classCode: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Class Code is required.') },
                    moreSuffix: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Class Code contains more than one suffix. Please select the appropriate Class Code and Suffix.') },
                    noOfEmployees: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Number of employees should be within the range of 0 to 2147483647 without decimal.') },
                    basis: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Please use only Estimated Wages for this class code within the range of 0 to 2147483647 without decimal.') },
                    perCapita: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Please use only Per Capita for this class code within the range of 0 to 2147483647 without decimal.') },
                    duplicate: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages. Class code already exists at location.') }
                };
                if (type != 'existing' && type != 'portal' && $scope.isDuplicate) {
                    $scope.employeeErrors.duplicate.status = true;
                    $scope.employeeErrors.duplicate.message = $filter('translate')(" Class code " + "  " + $scope.employeeView.classCode.value.code + "-" + $scope.employeeView.classCode.value.mSFClassIndicator + " " + "already exists at location" + " " + $scope.employeeView.location.value.locationDisplayName + ".");
                }

                if ($scope.employeeView.noOfEmployees.value !== '' && $scope.employeeView.noOfEmployees.value !== null && $scope.employeeView.noOfEmployees.value !== undefined) {
                    if (validNumber.test($scope.employeeView.noOfEmployees.value) === false || $scope.employeeView.noOfEmployees.value % 1 !== 0 || $scope.employeeView.noOfEmployees.value < 1 || $scope.employeeView.noOfEmployees.value > 2147483647) {
                        $scope.employeeErrors.noOfEmployees.status = true;
                        $scope.employeeErrors.noOfEmployees.message = $filter('translate')('Number of Employees should be within the range of 1 to 2147483647 without decimal.');
                    }
                }
                if (!$scope.employeeView.value.location) {
                    $scope.employeeErrors.location.status = true;
                } else if (!$scope.employeeView.value.classCode) {
                    $scope.employeeErrors.classCode.status = true;
                } else if ($scope.moreSuffix) {

                    $scope.employeeErrors.moreSuffix.status = true;

                    $scope.employeeErrors.moreSuffix.message = $scope.employeeView.value.classCode.code + ' selected class contains more than one suffix. 00 suffix may not be used.';
                } else {

                    if ($scope.perCapitaClasses && $scope.perCapitaClasses.indexOf($scope.employeeView.value.classCode.code) != -1) {
                        if ($scope.employeeView.perCapita.value === '' || validNumber.test($scope.employeeView.perCapita.value) === false || $scope.employeeView.perCapita.value % 1 !== 0 || $scope.employeeView.perCapita.value < 0 || $scope.employeeView.perCapita.value > 2147483647) {
                            $scope.employeeErrors.perCapita.status = true;
                            $scope.employeeErrors.perCapita.message = 'Please use only Per Capita for the class code ' + $scope.employeeView.value.classCode.code + ' within the range of 0 to 2147483647 without decimal.';
                        }
                        if ($scope.employeeView.value.basisAmount !== '' && $scope.employeeView.value.basisAmount !== null && $scope.employeeView.value.basisAmount !== undefined && $scope.employeeErrors.perCapita.status === false) {
                            $scope.employeeErrors.basis.status = true;
                            $scope.employeeErrors.basis.message = 'Please use only Per Capita for the class code ' + $scope.employeeView.value.classCode.code + ' within the range of 0 to 2147483647 without decimal.';
                        }
                    } else {
                        if ($scope.employeeView.value.basisAmount === '' || validNumber.test($scope.employeeView.value.basisAmount) === false || $scope.employeeView.value.basisAmount % 1 !== 0 || $scope.employeeView.value.basisAmount < 0 || $scope.employeeView.value.basisAmount > 2147483647) {
                            $scope.employeeErrors.basis.status = true;
                            $scope.employeeErrors.basis.message = 'Please use only Estimated Wages for the class code ' + $scope.employeeView.value.classCode.code + ' within the range of 0 to 2147483647 without decimal.';
                        }
                        if ($scope.employeeView.perCapita.value !== '' && $scope.employeeView.perCapita.value !== null && $scope.employeeView.perCapita.value !== undefined && $scope.employeeErrors.basis.status === false) {
                            console.log($scope.employeeView.perCapita.value);
                            $scope.employeeErrors.perCapita.status = true;
                            $scope.employeeErrors.perCapita.message = 'Please use only Estimated Wages for the class code ' + $scope.employeeView.value.classCode.code + ' within the range of 0 to 2147483647 without decimal.';
                        }
                    }
                }
            };

            /**
             * Method to check the error status of the employee
             * employeeErrors scope values are getting from updateEmployeeErrors method
             * @return ("displayEmployeeError", "id the employee error status is true then the error message should display")
             */
            $scope.checkEmployeeErrors = function () {
                $scope.displayEmployeeError = false;
                angular.forEach($scope.employeeErrors, function (error) {
                    if (error.status === true) {
                        $scope.displayEmployeeError = true;
                        return;
                    }
                });
                return $scope.displayEmployeeError;
            };

            /**
             * Method to save employee data for renewal payroll survey
             * @param ("type", "employee data which have been created from PC (existing), employee data which has been created from Portal (portal)")
             * push employees data to the portalCoveredEmployees array based on the condition
             */
            $scope.onSave = function (type) {
                //Execute main method 
                $scope.updateEmployeeErrors(type);
                if ($scope.checkEmployeeErrors() != true) {
                    if ($scope.employeeView.value.basisAmount === '' || $scope.employeeView.value.basisAmount === null || $scope.employeeView.value.basisAmount === undefined) delete $scope.employeeView.value.basisAmount;
                    if ($scope.employeeView.value.perCapita === '' || $scope.employeeView.value.perCapita === null || $scope.employeeView.value.perCapita === undefined) delete $scope.employeeView.value.perCapita;
                    if ($scope.employeeView.value.noOfEmployees === '' || $scope.employeeView.value.noOfEmployees === null || $scope.employeeView.value.noOfEmployees === undefined) delete $scope.employeeView.value.noOfEmployees;
                    /**
                     * Round up decimal places
                     */
                    if ($scope.employeeView.value.noOfEmployees !== '' && $scope.employeeView.value.noOfEmployees !== null && $scope.employeeView.value.noOfEmployees !== undefined) $scope.employeeView.noOfEmployees.value = Math.round($scope.employeeView.noOfEmployees.value);
                    if ($scope.employeeView.value.basisAmount !== undefined && $scope.employeeView.value.basisAmount !== null && $scope.employeeView.value.basisAmount !== '') {
                        $scope.employeeView.value.basisAmount = Math.round($scope.employeeView.value.basisAmount);
                    }
                    if ($scope.employeeView.value.perCapita !== undefined && $scope.employeeView.value.perCapita !== null && $scope.employeeView.value.perCapita !== '') $scope.employeeView.value.perCapita = Math.round($scope.employeeView.value.perCapita);
                    if ($scope.selectedEntry > -1) {
                        if (type == 'existing') {
                            if ($scope.employeeView.value.noOfEmployees === '' || $scope.employeeView.value.noOfEmployees === null || $scope.employeeView.value.noOfEmployees === undefined) delete $scope.renewalData.mSFWCCoveredEmployees[$scope.selectedEntry].noOfEmployees;else $scope.renewalData.mSFWCCoveredEmployees[$scope.selectedEntry].noOfEmployees = $scope.employeeView.value.noOfEmployees;
                            if ($scope.employeeView.value.basisAmount === '' || $scope.employeeView.value.basisAmount === null || $scope.employeeView.value.basisAmount === undefined) delete $scope.renewalData.mSFWCCoveredEmployees[$scope.selectedEntry].basisAmount;else $scope.renewalData.mSFWCCoveredEmployees[$scope.selectedEntry].basisAmount = $scope.employeeView.value.basisAmount;
                            if ($scope.employeeView.value.perCapita === '' || $scope.employeeView.value.perCapita === null || $scope.employeeView.value.perCapita === undefined) delete $scope.renewalData.mSFWCCoveredEmployees[$scope.selectedEntry].perCapita;else $scope.renewalData.mSFWCCoveredEmployees[$scope.selectedEntry].perCapita = $scope.employeeView.value.perCapita;
                        }
                        if (type == 'portal') $scope.coveredEmployees[$scope.selectedEntry] = $scope.employeeView.value;
                    } else {
                        if (angular.isDefined($scope.portalCoveredEmployees) && $scope.portalCoveredEmployees.length > 0) {
                            $scope.portalCoveredEmployees.push($scope.employeeView.value);
                        } else {
                            $scope.portalCoveredEmployees = [$scope.employeeView.value];
                        }
                    }
                    $scope.selectedEntry = -1;
                    $scope.isAddingNew = false;
                    $scope.isEditing = false;
                } else {
                    $scope.errors = true;
                    return false;
                }
            };

            /**
             * Method to remove selected covered employee details based on the index value
             * @param ("index", "index which has been selected from the portal")
             * Remove the employee data from the portalCoveredEmployees array by passing index
             */
            $scope.onRemove = function (index) {
                if (index !== 'new' && $scope.portalCoveredEmployees) $scope.portalCoveredEmployees.splice(index, 1);
                $scope.isAddingNew = false;
                $scope.isEditing = false;
                //Execute the main method
                $scope.resetErrors();
            };

            /**
             * Method to submit covered employee details to server 
             * @param ("portalCoveredEmployees", "employee details which has been added newly from portal")
             * @param ("existingEmployees", "employee details which has been existing already")
             */
            $scope.onSubmit = function () {
                $scope.isSubmitting = true;
                $scope.saveCoveredEmployees({ data: { portalcoveredEmployees: $scope.portalCoveredEmployees, existingEmployees: $scope.renewalData.mSFWCCoveredEmployees } });
            };
        }]

    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/RenewalPayrollDirective/RenewalPayroll.js
// module id = 1764
// module chunks = 0